export default __webpack_public_path__ + "static/media/react-svg.73ac128a.png";